module.exports = __webpack_public_path__ + "static/media/iconPdf.09318909.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/iconPdf.svg
// module id = 195
// module chunks = 0